import { Icon, IconProps } from '@chakra-ui/react'

export default function OperationalIcon(props: IconProps) {
  const strokeWidth = props.strokeWidth ?? '0.75'

  return (
    <Icon
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#495057'}
      {...props}
    >
      <path
        d="M2 10C2 8.75 3 7.75 4.25 7.75H5.55"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.4 7.64922C8.6 7.54922 8.85 7.54922 9.1 7.64922L10 7.99922V9.04922C10 9.94922 8.75 10.5492 8.75 10.5492C8.75 10.5492 7.5 9.94922 7.5 9.04922V7.99922L8.4 7.64922Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 2.6C8.35 3.45 8.35 4.8 7.5 5.6C6.65 6.4 5.3 6.45 4.5 5.6C3.7 4.75 3.65 3.4 4.5 2.6C5.35 1.8 6.65 1.8 7.5 2.6"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
